import { useEffect } from "react";
import ChatPage from "../common/ChatPage";
import Loader from "../../components/loader";
import { getProfile } from "../../utils/pip";
import { useDispatch, useSelector } from "react-redux";
import FreelancerLayout from "../../layouts/FreelancerLayout";
import { setActiveChat } from "../../redux/features/chat/chatSlice";
import { SocketBootstrap } from "../../components/chat/SocketBootstrap";
const Inbox = () => {
  const dispatch = useDispatch();
  const user = getProfile("freelancer");

  const { subLoading } = useSelector((state) => state.freelancer.auth);
  useEffect(() => {
    return () => {
      dispatch(setActiveChat(null));
    };
  }, []);
  if (subLoading) {
    return <Loader />;
  }
  return (
    <div>
      <FreelancerLayout>
        <SocketBootstrap role="freelancer" />
        <ChatPage userId={user.user_id} role={"freelancer"} />
      </FreelancerLayout>
    </div>
  );
};

export default Inbox;
